
import React, {useEffect, useState} from "react";
import API, {ROUTES} from "../../../commons/api/api";
import {useParams} from "react-router-dom";
import QnaCreatePageComponent from "./../components/create"

const QnaCreatePageContainer  = () => {

    const [qnaCategories, setQnaCategories] = useState([])
    const params = useParams();
    var id = params?.id ? params?.id : ''

    const fetchData = async (param = '?per_page=0') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_QNA_CATEGORIES+param);
            setQnaCategories(response?.data);
        } catch (error) {
            console.error(error.message);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const loadMoreData = () => {

    }

    return <QnaCreatePageComponent qnaCategories={qnaCategories} />;
};

export default QnaCreatePageContainer ;